import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "transportation-route-container d-flex flex-sm-column flex-lg-row justify-content-lg-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransportationStopsContainerComponent = _resolveComponent("TransportationStopsContainerComponent")!
  const _component_CustomRouteMapTemplateComponent = _resolveComponent("CustomRouteMapTemplateComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TransportationStopsContainerComponent, { "transportation-data": _ctx.data }, null, 8, ["transportation-data"]),
    _createVNode(_component_CustomRouteMapTemplateComponent, {
      class: "map-modal-container-width",
      "map-id": `map-${_ctx.data.id}`
    }, null, 8, ["map-id"])
  ]))
}